import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function TickIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 24 24"
    >
      <G fill={color} fillRule="evenodd">
        <Path d="M0 0h24v24H0z" fill="none" />
        <Path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      </G>
    </Svg>
  );
}

TickIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

TickIcon.defaultProps = {
  height: 16,
  width: 16,
};

export default pure(TickIcon);
